package com.nonopn.skywatcher.common.app.pages.map.view.map

import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.Icon
import androidx.compose.material.icons.Icons
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.unit.dp
import com.nonopn.icons.FixedGps
import com.nonopn.icons.ZoomIn
import com.nonopn.icons.ZoomOut
import com.nonopn.skywatcher.common.app.api.impl.ThunderDetectionSurroundingContext
import com.nonopn.skywatcher.common.app.api.impl.ThunderDetectionSurroundingUser
import com.nonopn.skywatcher.common.app.api.impl.WarnStateValidationState
import com.nonopn.skywatcher.common.app.home.HotPreviewApp
import com.nonopn.skywatcher.common.app.pages.map.model.FakeMainScreenModel
import com.nonopn.skywatcher.common.app.pages.map.model.MainScreenModel
import com.nonopn.skywatcher.design.theme.LocalApplicationColorTheme
import com.nonopn.skywatcher.design.utils.LocalFrame
import com.nonopn.skywatcher.design.utils.WindowType
import com.nonopn.skywatcher.design.widgets.DefaultCard
import com.nonopn.skywatcher.design.widgets.defaultCardBackground
import de.drick.compose.hotpreview.HotPreview
import eu.codlab.compose.theme.LocalThemeEnvironment
import eu.codlab.platform.Platform
import eu.codlab.platform.currentPlatform

@Composable
fun MapButtons(
    modifier: Modifier,
    model: MainScreenModel
) {
    val color = defaultCardBackground()
    val theme = LocalThemeEnvironment.current

    Column(
        modifier = modifier,
        // backgroundColor = color,
        //columnModifier = Modifier.padding(8.dp)
    ) {
        if (LocalFrame.current == WindowType.TABLET || LocalFrame.current == WindowType.PHABLET) {
            Row(
                Modifier.height(50.dp),
                horizontalArrangement = Arrangement.spacedBy(8.dp),
                verticalAlignment = Alignment.CenterVertically
            ) {
                ShowActions(model)
            }
        } else {
            Column(
                verticalArrangement = Arrangement.spacedBy(8.dp),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                ShowActions(model)
            }
        }
    }
}

@Composable
private fun Button(
    imageVector: ImageVector,
    contentDescription: String,
    onClick: () -> Unit,
) {
    val colors = LocalApplicationColorTheme.current
    val color = defaultCardBackground()

    val corner = RoundedCornerShape(50)

    Column(Modifier.clip(corner)) {
        DefaultCard(
            onClick = onClick,
            backgroundColor = color,
            shape = corner,
            columnModifier = Modifier.padding(8.dp)
        ) {
            Icon(
                imageVector = imageVector,
                contentDescription = contentDescription,
                tint = colors.fonts.regular
            )
        }
    }
}

@Composable
private fun ShowActions(
    model: MainScreenModel
) {
    val mobile = currentPlatform == Platform.IOS || currentPlatform == Platform.ANDROID

    if (!mobile) {
        Button(
            imageVector = Icons.Rounded.ZoomIn,
            contentDescription = "Zoom In",
            onClick = { model.zoomIn() }
        )
        Button(
            imageVector = Icons.Rounded.ZoomOut,
            contentDescription = "Zoom Out",
            onClick = { model.zoomOut() }
        )
    }
    Button(
        imageVector = Icons.Rounded.FixedGps,
        contentDescription = "GPS",
        onClick = { model.moveToOrigin() }
    )
}

@Composable
@HotPreview(widthDp = 250, heightDp = 50, darkMode = true)
@HotPreview(widthDp = 250, heightDp = 50, darkMode = false)
private fun MapButtonsPreview() {
    HotPreviewApp(Modifier.fillMaxSize(), isDarkTheme = isSystemInDarkTheme()) {
        MapButtons(
            Modifier.fillMaxSize(),
            FakeMainScreenModel(
                false,
                null,
                ThunderDetectionSurroundingContext(
                    (0..94).map {
                        ThunderDetectionSurroundingUser(
                            id = "$it",
                            latitude = 0.0,
                            longitude = 0.0,
                            alertState = WarnStateValidationState.AllClear
                        )
                    }
                )
            )
        )
    }
}
